import { ConfigReader } from '../config/configReader';

export interface PageMetaResponse {
  postId: string;
  title: string;
  description: string;
  type: string;
  url: string;
  robots: string;
  locale: string;
  siteName: string;
  image: string;
}

export class PageApi {
  public static readonly BASE_URL = ConfigReader.getApiDomain();

  static async getPageMeta(path: string): Promise<PageMetaResponse> {
    const res = await fetch(`${PageApi.BASE_URL}/page/meta?path=${path}`);
    if (!res.ok) {
      const error = await res.text();
      throw new Error(error);
    }
    return res.json();
  }
}
